import { Link } from '@tanstack/react-router';
import { Download, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ScrollReveal } from '@/components/common/ScrollReveal';

/**
 * CTASection
 * 最終コンバージョンセクション
 * DL/Web CTA + プランリンク
 */
export function CTASection() {
  return (
    <section className="bg-muted px-6 md:px-16 lg:px-24 py-32 md:py-40 text-center">
      <div className="max-w-3xl mx-auto">
        <ScrollReveal direction="up" delay={0.1}>
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight leading-tight mb-5">
            VRChatの思い出を、
            <br />
            もっと大切に。
          </h2>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={0.2}>
          <p className="text-lg text-muted-foreground leading-relaxed mb-12">
            デスクトップアプリもWebアプリも、基本機能は無料で使える。
            <br />
            クラウドストレージ5GB付き。
          </p>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={0.3}>
          <div className="flex flex-wrap justify-center items-center gap-4 mb-4">
            <Button asChild size="lg" className="gap-2">
              <Link to="/download">
                <Download className="w-4 h-4" />
                ダウンロード (Windows)
              </Link>
            </Button>
            <Button asChild variant="ghost" size="lg">
              <Link to="/login">Webで始める</Link>
            </Button>
          </div>
          <p className="text-[13px] text-muted-foreground mt-4">
            有料プランもあります。
            <Link
              to="/pricing"
              className="text-accent hover:underline ml-1 inline-flex items-center gap-1"
            >
              プランを見る
              <ArrowRight className="w-3 h-3" />
            </Link>
          </p>
        </ScrollReveal>
      </div>
    </section>
  );
}
